import React, { Fragment, useEffect, useState, useContext, useMemo } from 'react';
import SidebarMenu from './SidebarMenu';
import CustomizerContext from '../../_helper/Customizer';
import { Home, Edit, Shield, FileText, BookOpen, Users, AlertTriangle, Book } from 'react-feather';
import Profile from './Profile';

function containsRolesDb(item) {
  return Object.prototype.hasOwnProperty.call(item, 'roles_db');
}

const unfilteredMENUITEMS = [
  {
      menutitle: 'Home',
      menucontent: 'Home',
      Items: [
          {
              title: 'Home', icon: Home, type: 'link', path: `${process.env.PUBLIC_URL}/home`, roles: ['all']
          },
          {
              title: 'Movimento ospiti', icon: Edit, type: 'link', path: `${process.env.PUBLIC_URL}/guests-movements`, roles: ['GOSP'] // gestione ospiti
          },
          {
              title: 'Ospiti', icon: Users, type: 'link', path: `${process.env.PUBLIC_URL}/guests`, roles: ['GOSP'] // gestione ospiti
          },
          {
              title: 'Turni antincendio', icon: Shield, type: 'link', path: `${process.env.PUBLIC_URL}/fire-fighters-shifts`, roles: ['SQAI'] // SQ ANTINCENDIO
          },
          {
              title: 'Notizie', icon: BookOpen, type: 'link', path: `${process.env.PUBLIC_URL}/news`, roles: ['all'] // pubblicatore(PUB) vede il tasto aggiungi notizia
          },
          {
              title: 'Dicono a noi', icon: BookOpen, type: 'link', path: `${process.env.PUBLIC_URL}/customer-comments`, roles: ['all'] // pubblicatore(PUB) vede il tasto aggiungi commento cliente
          },
          {
              title: 'Documenti', icon: FileText, type: 'link', path: `${process.env.PUBLIC_URL}/documents`, roles: ['all'] // tutti vedono
          },
          {
              title: 'Segnalazioni', icon: AlertTriangle, type: 'link', path: `${process.env.PUBLIC_URL}/reports`, roles: ['all'] // tutti vedono
          },
          {
              title: 'Questionari', icon: Book, type: 'link', path: `${process.env.PUBLIC_URL}/questionnaires`, roles: ['all'] // tutti vedono
          },
          {
              title: 'Gestione utenti', icon: Users, type: 'link', path: `${process.env.PUBLIC_URL}/users-management`, roles: ['GUTN'] // gestione utenti
          },
      ]
  },
];

const SideBarLayout = (props) => {
  const { toggleIcon } = useContext(CustomizerContext);
  const [currentUrl] = useState(window.location.pathname);
  const id = window.location.pathname.split('/').pop();
  // get user db roles
  const [usrDbRoles, setUsrDbRoles] = useState([]);
  useEffect(() => {
    let userData = localStorage.getItem("user_data");
    if (userData !== null) {
      let userDataObj = JSON.parse(userData);
      if (containsRolesDb(userDataObj)) {
        setUsrDbRoles(userDataObj.roles_db);
      }
    }
  }, [])
  
  const MENUITEMS = useMemo(() => {
      return unfilteredMENUITEMS.map(menu => {
          return {
              ...menu,
              Items: menu.Items.filter(item => item.roles.includes('all') || item.roles.some(role => usrDbRoles.includes(role)))
          };
      });
  }, [usrDbRoles]);

  // eslint-disable-next-line
  const [leftArrow, setLeftArrow] = useState(false);
  const layout = id;
  const [width, setWidth] = useState(0);
  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };// eslint-disable-next-line
  const [mainmenu, setMainMenu] = useState(MENUITEMS);
  const handleScroll = () => {
    if (window.scrollY > 400) {
      document.querySelector('.main-navbar').className =
        'main-navbar hovered';
    } else {
      if (document.getElementById('main-navbar'))
        document.querySelector('.main-navbar').className = 'main-navbar';
    }
  };

  const setNavActive = (item) => {
    MENUITEMS.map(menuItems => {
      menuItems.Items.filter(Items => {
        if (Items !== item) {
          Items.active = false;
          document.getElementById('bg-overlay1').classList.remove('active');
        }
        if (Items.children && Items.children.includes(item)) {
          Items.active = true;
        }
        if (Items.children) {
          Items.children.filter(submenuItems => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;
              submenuItems.active = true;
              return true;
            } else {
              return false;
            }
          });
        }
        return Items;
      });
      return menuItems;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };
  useEffect(() => {
    setLeftArrow(true);
    window.addEventListener('resize', handleResize);
    handleResize();
    const currentUrl = window.location.pathname;
    MENUITEMS.map(items => {
      items.Items.filter((Items) => {
        if (Items.path === currentUrl)
          setNavActive(Items);
        if (!Items.children) return false;
        Items.children.filter(subItems => {
          if (subItems.path === currentUrl)
            setNavActive(subItems);
          if (!subItems.children) return false;
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === currentUrl) {
              setNavActive(subSubItems);
              return true;
            } else {
              return false;
            }
          });
          return subItems;
        });
        return Items;
      });
      return items;
    });
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line
  }, [layout, currentUrl]);

  const closeOverlay = () => {
    document.getElementById('bg-overlay1').classList.remove('active');
    document.getElementById('nav-link').classList.remove('active');
  };

  return (
    <Fragment>
      <div id="bg-overlay1" onClick={() => {
        closeOverlay();
      }} ></div>
      <header className={`main-nav ${toggleIcon ? 'close_icon' : ''}`}>
        <Profile />
        <SidebarMenu setMainMenu={setMainMenu} props={props} sidebartoogle={true} setNavActive={setNavActive} width={width} menuItems={MENUITEMS} />
      </header>
    </Fragment>
  );
};
export default SideBarLayout;